import React, { Fragment, Component } from 'react';
import ReactGA from 'react-ga';

import InlineError from '../InlineError/';

import './errorBoundary.scss';

export default class ErrorBoundary extends Component {
  constructor(props) {
    super(props);
    this.state = { error: props.error, text: props.text };
  }

  static getDerivedStateFromError(error) {
    return { error };
  }

  componentDidCatch(error) {
    ReactGA.exception({
      description: `${error.name}: ${error.message} (${error.code || 500})`,
      fatal: true
    });
  }

  render() {
    const { error, text } = this.state;

    return (
      <Fragment>
        {this.props.children}
        {error && <InlineError error={error} text={text} />}
      </Fragment>
    );
  }
}
